import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Context } from "../../Helpers/Auth";

const Breadcrumb = ({ frase }) => {
  const [search, setSearch] = useState("");
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(false);
  const [secondItemText, setSecondItemText] = useState("");
  const { path } = useContext(Context);

  const { t } = useTranslation();

  useEffect(() => {
    setIsHomePage(location.pathname === "/Dashboard");

    switch (location.pathname) {
      case "/Dashboard":
        setSecondItemText("");
        break;
        case "/Leads":
        setSecondItemText(t("Leads"));
        break;
      case "/Prospects":
        setSecondItemText(t("contas"));
        break;
      case "/Agendamentos":
        setSecondItemText(t("agendamentos"));
        break;
      case "/Catalogo":
        setSecondItemText(t("catalogo"));
        break;
      case "/Propostas":
        setSecondItemText(t("propostas"));
        break;
      case "/NegociosEtapas":
        setSecondItemText(t("negocios"));
        break;
      case "/Despesas":
        setSecondItemText(t("despesas"));
        break;
      case "/Questionarios":
        setSecondItemText(t("questionarios"));
        break;
      case "/Relatorios":
        setSecondItemText(t("relatorios"));
        break;
      default:
        setSecondItemText("");
        break;
    }
  }, [location.pathname]);

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <a
            href="/Dashboard"
            className={`inline-flex items-center text-sm font-medium ${
              isHomePage
                ? "text-blue-600 dark:text-blue-600"
                : "text-gray-700 dark:text-gray-400"
            } focus:text-blue-600 hover:text-blue-600 dark:hover:text-blue-600`}
          >
            <svg
              className="w-3 h-3 mr-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
            </svg>
            {t("home")}
          </a>
        </li>
        {secondItemText && (
          <li>
            <a className="flex items-center" href={location.pathname}>
              <svg
                className="w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span
                className={`ml-1 text-sm font-medium ${
                  secondItemText != "" && !path
                    ? "text-blue-600 dark:text-blue-600 dark:hover:text-blue-600 hover:text-blue-600"
                    : "text-gray-700 dark:text-gray-400 dark:hover:text-blue-600 hover:text-blue-600"
                } md:ml-2`}
              >
                {secondItemText}
              </span>
            </a>
          </li>
        )}
        {path && (
          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span
                className={`ml-1 text-sm font-medium ${
                  path != ""
                    ? "text-blue-600 dark:text-blue-600"
                    : "text-gray-700 dark:text-gray-400"
                } md:ml-2`}
              >
                {path}
              </span>
            </div>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
